import { render, staticRenderFns } from "./SelectBoxSingleValueField.vue?vue&type=template&id=52d50768&scoped=true&"
import script from "./SelectBoxSingleValueField.vue?vue&type=script&lang=js&"
export * from "./SelectBoxSingleValueField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d50768",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
